<template>
  <div class="leave height-100">

    <b-modal :active.sync="showLeaveModal">
      <div class="box" style="max-width: 400px; margin: 0 auto;" v-if="selected">
        <div class="bold font-size-150">{{ selected.user | name }}</div>
        <div class="pad-top">{{ selected.fromTimestamp | unixToDateString }} to {{ selected.toTimestamp | unixToDateString }}</div>
        <div class="has-text-grey uc pad-top bold">
          <template v-if="selected.approved">approved</template>
          <template v-else>pending approval</template>
        </div>
        <div class="buttons pad-top">
          <div class="flex-1">
            <button class="button is-danger" :class="{'is-loading': submitting === 'cancel'}" v-if="canCancel" @click="onCancel(selected)">Cancel</button>
            <button class="button is-success" :class="{'is-loading': submitting === 'approve'}" v-if="canApprove" @click="onApprove(selected)">Approve</button>
            <button class="button is-danger" :class="{'is-loading': submitting === 'reject'}" v-if="canReject" @click="onReject(selected)">Reject</button>
            <button class="button is-danger" :class="{'is-loading': submitting === 'remove'}" v-if="canRemove" @click="onRemove(selected)">Remove</button>
          </div>
          <div>
            <button class="button" @click="showLeaveModal = false">Close</button>
          </div>
        </div>

      </div>
    </b-modal>

    <leave-request v-if="showAddLeaveRequest" @close="showAddLeaveRequest = false" />

    <div class="pad" v-if="!showAddLeaveRequest">
      <div class="center pad-bottom-10">
        <button class="button is-info" @click="showAddLeaveRequest = true">Request Leave</button>
      </div>
      <div class="month">
        <div class="month-heading flex">
          <div class="pointer pad-right" @click="move(-1)"><fa icon="angle-left" /></div>
          <div class="flex-1">{{ monthStr }}</div>
          <div class="pointer pad-left" @click="move(1)"><fa icon="angle-right" /></div>
        </div>
        <div class="weeks-headings">
          <div class="weeks-heading flex-1" v-for="w in weekHeadings" :key="w">{{ w }}</div>
        </div>
        <div class="weeks">
          <div class="week" v-for="(week, weekIndex) in weeks" :key="weekIndex">
            <div class="day flex-1"
              :class="{ 'not-this-month': day.month !== month }" v-for="day in week" :key="day.timestamp"
              :style="{'min-height': cellHeight}"
            >
              <div class="day-title">
                <span class="pad-right-5 day-name">{{ day.dayName }}</span>
                <span class="date">{{ day.date }}</span>
              </div>
              <div class="day-content">
                <template  v-for="(leave, leaveIndex) in day.leave">
                  <div v-if="leave"
                    :key="leaveIndex"
                    class="day-leave pointer"
                    :class="getLeaveClass(day, leave, leaveIndex)"
                    @click="onClickLeave(leave)"
                  >
                    {{ leave.user.firstName}} {{ leave.user.lastName}}
                  </div>
                  <div v-else class="day-leave empty" :key="leaveIndex">&nbsp;</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- .leave .weeks .week .day .day-content .day-leave.approved { -->

      <div class="weeks">
        <div class="week">
          <div class="day" style="margin: 0 auto;">
            <div class="day-content" style="width: 200px; margin: 0 auto;">
              <div class="day-leave approved start end center color-0" style="margin-top: 10px;">Approved</div>
              <div class="day-leave pending start end center color-0" style="margin-top: 10px;">Pending Approved</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />

  </div>
</template>

<style lang="css">
</style>

<script>
import LeaveRequest from '@/components/LeaveRequest'

export default {
  name: 'Leave',
  components: { LeaveRequest },
  data () {
    return {
      showAddLeaveRequest: false,
      timestamp: 0,
      fromTimestamp: 0,
      toTimestamp: 0,
      month: null,
      monthStr: null,
      weekHeadings: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weeks: null,
      days: {},
      userCount: 0,
      showLeaveModal: false,
      selected: null,
      submitting: null
    }
  },
  computed: {
    user () { return this.$store.getters.user },
    canTakeLeave () { return this.user && this.user.privileges.includes('leave') },
    isAdmin () { return this.user && this.user.privileges.includes('leave admin') },
    cellHeight () { return `${Math.max(100, 10 + (this.userCount + 1) * 22)}px` },
    canCancel () { return !this.isAdmin && !this.selected.approved && this.selected.user._id === this.user._id },
    canApprove () { return !this.selected.approved && this.isAdmin },
    canReject () { return !this.selected.approved && this.isAdmin },
    canRemove () { return this.selected.approved && this.isAdmin }
  },
  created () {
    this.timestamp = this.$moment().startOf('month').unix()
    this.initWeeks()
  },
  methods: {
    onCancel (leave) {
      this.submitting = 'cancel'
      this.deleteLeave(leave)
    },
    async onApprove (leave) {
      this.submitting = 'approve'
      await this.$fs.collection('leave').doc(leave._id).update({ approved: true })
      this.submitting = null
      this.showLeaveModal = false
    },
    async onReject (leave) {
      this.submitting = 'reject'
      this.deleteLeave(leave)
    },
    onRemove (leave) {
      this.submitting = 'remove'
      this.deleteLeave(leave)
    },
    async deleteLeave (leave) {
      let showingModal = this.showLeaveModal
      this.showLeaveModal = false
      let comfirmed = await this.$confirm({
        type: 'is-danger',
        title: `${this.submitting.toUpperCase()} LEAVE`,
        message: `Are you sure you want to ${this.submitting} this leave?`
      })
      this.showLeaveModal = showingModal
      if (comfirmed) {
        await this.$fs.collection('leave').doc(leave._id).delete()
        this.showLeaveModal = false
      }
      this.submitting = null
    },
    getLeaveClass (day, leave, index) {
      let classes = [
        `color-${index}`,
        leave.approved ? 'approved' : 'pending'
      ]
      if (leave.fromTimestamp === day.timestamp) classes.push('start')
      if (leave.toTimestamp === day.timestamp) classes.push('end')
      return classes
    },
    onClickLeave (leave) {
      this.selected = leave
      this.showLeaveModal = true
    },
    move (inc) {
      this.timestamp = this.$moment.unix(this.timestamp)
        .add(inc, 'months')
        .unix()
      this.initWeeks()
    },
    onLeaveSnapshot (snapshot) {
      let data = this.$utils.snapshotToArr(snapshot)

      for (let timestamp in this.days) {
        this.days[timestamp].leave = null
      }

      let userIndex = {}
      this.userCount = 0
      for (let leave of data) {
        let index = userIndex[leave.user._id]
        if (index === undefined) {
          userIndex[leave.user._id] = this.userCount++
        }
      }

      for (let leave of data) {
        let fromTimestamp = Math.max(leave.fromTimestamp, this.fromTimestamp)
        for (let timestamp = fromTimestamp; timestamp <= leave.toTimestamp; timestamp += 60 * 60 * 24) {
          if (timestamp > this.toTimestamp) {
            break
          }
          let day = this.days[timestamp]
          if (!day) {
            console.log('invalid day?', leave)
            continue
          }
          if (!day.leave) {
            day.leave = []
            for (let i = 0; i < this.userCount; i++) day.leave.push(null)
          }
          let i = userIndex[leave.user._id]
          if (i === undefined) {
            console.log('invalid user index', leave)
          }
          day.leave[i] = leave
        }
      }
    },
    initWeeks () {
      let m = this.$moment.unix(this.timestamp)
      this.month = m.month()
      this.monthStr = m.format('MMMM YYYY')
      m = m.startOf('month').startOf('week').startOf('day')
      this.fromTimestamp = m.unix()
      this.toTimestamp = this.$moment.unix(this.timestamp).endOf('month').endOf('week').unix()
      let timestamp = this.fromTimestamp

      let weeks = []
      let week = null
      let days = {}

      let count = 0
      while (timestamp < this.toTimestamp && count < 100) {
        let day = {
          timestamp,
          year: m.year(),
          month: m.month(),
          date: m.date(),
          dayName: m.format('ddd'),
          leave: []
        }
        let dow = m.day()
        days[timestamp] = day
        if (dow === 0) {
          week = []
          weeks.push(week)
        }
        week.push(day)
        m.add(1, 'day')
        timestamp = m.unix()
        count++
      }
      this.weeks = weeks
      this.days = days

      this.fetchLeave()
    },
    fetchLeave () {
      this.unsub('leave')
      this.subs.leave = this.$fs.collection('leave')
        .where('months', 'array-contains', this.month)
        .orderBy('approved', 'desc')
        .orderBy('requestedTimestamp', 'asc')
        .onSnapshot(this.onLeaveSnapshot)
    }
  }
}
</script>

<style>
  .leave .month {
    max-width: 1000px;
    margin: 0 auto;
    border: solid 2px #666;
  }

  .leave .month-heading {
    padding: 10px;
    font-size: 1.1em;
  }

  .leave .month-heading,
  .leave .weeks-headings {
    text-align: center;
    color: #fff;
    background-color: #666;
    font-weight: bold;
  }

  .leave .weeks-headings .weeks-heading {
    padding: 5px;
    font-size: 12px;
    /* border-right: solid 1px #ccc; */
    /* border-bottom: solid 2px #ccc; */
  }

  .leave .weeks .week {
    display: flex;
  }

  .leave .weeks .week .day {
    border-right: solid 2px #666;
    border-bottom: solid 2px #666;
    height: 100px;
    overflow: hidden;
  }

  .leave .weeks .week .day .day-title {
    height: 20px;
    font-size: 11px;
    line-height: 20px;
    padding: 0 2px;
    font-weight: bold;
    color: #000;
    background-color: #dddd;
  }

  /* .leave .weeks .week .day .day-content {
  } */

  .leave .weeks .week .day.not-this-month {
    opacity: 0.5;
    background-color: #eee;
  }

  .leave .weeks .week .day .day-content .day-leave {
    height: 18px;
    line-height: 15px;
    padding: 0 5px;
    margin: 2px 0;
    width: 100%;
    font-size: 13px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    border-top: solid 2px transparent;
    border-bottom: solid 2px transparent;
  }

  .leave .weeks .week .day .day-content .day-leave.start {
    margin-left: 5%;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-left: solid 2px transparent;
  }

  .leave .weeks .week .day .day-content .day-leave.end {
    width: 95%;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    border-right: solid 2px transparent;
  }

  .leave .weeks .week .day .day-content .day-leave.start.end {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }

  .leave .weeks .week .day .day-content .day-leave.approved {
    font-weight: bold;
    /* color: #fff; */
    /* background-color: #167df0; */
  }

  .leave .weeks .week .day .day-content .day-leave.pending {
    /* background-color: rgba(50, 152, 220, 0.2); */
    /* background-color: #eee; */
  }

  .leave .weeks .week .day .day-content .day-leave.approved.color-0 { background-color: mediumaquamarine; }
  .leave .weeks .week .day .day-content .day-leave.approved.color-1 { background-color: navajowhite; }
  .leave .weeks .week .day .day-content .day-leave.approved.color-2 { background-color: violet; }
  .leave .weeks .week .day .day-content .day-leave.approved.color-3 { background-color: powderblue; }
  .leave .weeks .week .day .day-content .day-leave.approved.color-4 { background-color: coral; }
  .leave .weeks .week .day .day-content .day-leave.approved.color-5 { background-color: mediumturquoise; }
  .leave .weeks .week .day .day-content .day-leave.approved.color-6 { background-color: lightpink; }
  .leave .weeks .week .day .day-content .day-leave.approved.color-7 { background-color: yellowgreen; }

  .leave .weeks .week .day .day-content .day-leave.pending.color-0 { border-color: mediumaquamarine; }
  .leave .weeks .week .day .day-content .day-leave.pending.color-1 { border-color: navajowhite; }
  .leave .weeks .week .day .day-content .day-leave.pending.color-2 { border-color: violet; }
  .leave .weeks .week .day .day-content .day-leave.pending.color-3 { border-color: powderblue; }
  .leave .weeks .week .day .day-content .day-leave.pending.color-4 { border-color: coral; }
  .leave .weeks .week .day .day-content .day-leave.pending.color-5 { border-color: mediumturquoise; }
  .leave .weeks .week .day .day-content .day-leave.pending.color-6 { border-color: lightpink; }
  .leave .weeks .week .day .day-content .day-leave.pending.color-7 { border-color: yellowgreen; }

  @media screen and (min-width: 650px) {
    .leave .weeks-headings { display: flex; }

    .leave .weeks .week .day .day-title .day-name {
      display: none;
    }

    .leave .weeks .week .day:last-child {
      border-right: none;
    }

    .leave .weeks .week:last-child .day {
      border-bottom: none;
    }
  }

  @media screen and (max-width: 650px) {
    .leave .weeks .week {
      display: block;
    }

    .leave .weeks .week .day {
      border-right: none;
    }

    .leave .weeks-headings,
    .leave .weeks .week .day.not-this-month {
      display: none;
    }

    .leave .month {
      border-bottom: none;
    }
  }
</style>
